import React from 'react';
import { LeaderBoard, AutoScroll, LeaderBoardEntry } from '@slope/uikit';
import { useStore } from '@slope/store';
import { GetLeaderBoardQuery, useGetLeaderBoardQuery } from '@slope/graphql/apollo';
import { useParams } from 'react-router';

export type LiveScoringProps = {
  children?: React.ReactNode;
};

/* const parseRoundNumberParam = (param: string | null | undefined): number | undefined => {
  if (!param) return undefined;
  const parsed = parseInt(param);
  return isNaN(parsed) ? undefined : parsed;
}; */

type PartialLeaderBoardRankingEntry = GetLeaderBoardQuery['leaderBoard']['ranking'][0];

const mapLeaderboard = (a: PartialLeaderBoardRankingEntry): LeaderBoardEntry => ({
  players: a.participation.players,
  rounds: [],
  startHole: a.participation.startHole?.number ?? null,
  teeTime: a.participation.teeTime ?? null,
  label: 'F',
  status: a.participation.status,
  score: a.score?.toPar ?? null,
  strokes: a.score?.strokes ?? 0,
});

export const LiveScoring: React.FC<LiveScoringProps> = () => {
  const liveScoring = useStore(({ ui: { liveScoring } }) => liveScoring);

  const { tournamentId /*, roundNumber*/ } = useParams<{
    tournamentId: string;
    roundNumber: string;
  }>();

  //const parsedRoundNumber = parseRoundNumberParam(roundNumber);
  const skip = !tournamentId || !liveScoring.enabled;

  const { data } = useGetLeaderBoardQuery({
    skip,
    variables: {
      tournamentId: tournamentId!,
      calcMode: liveScoring.calcMode,
    },
    pollInterval: 5_000,
  });

  /* const playersSorted = useMemo<MatchLeaderboard[]>(
    // @ts-expect-error TODO fix ts error
    () => [...(data?.leaderBoard. ?? [])].map(mapLeaderboard),
    [data?.leaderBoard],
  ); */

  const leaderboardData = (data?.leaderBoard.ranking ?? []).map(mapLeaderboard) ?? [];

  if (!liveScoring.enabled) {
    return null;
  }

  return (
    <AutoScroll duration={leaderboardData.length * 3000}>
      <LeaderBoard leaderboard={leaderboardData} />
    </AutoScroll>
  );
};
